import { createActions, createReducer } from 'reduxsauce';
import { combineReducers } from 'redux';

export const { Types: types, Creators: actions } = createActions(
  {
    reserveCoupon: ['couponId', 'payByPoints', 'resolve', 'reject'],
    reserveCouponSuccess: ['couponId', 'data'],
    reserveCouponFailure: ['couponId', 'error'],
  },
  { prefix: 'cb/coupons/reserve/' },
);

export const reserveCoupon = combineReducers({
  fetching: createReducer(false, {
    [types.RESERVE_COUPON]: () => true,
    [types.RESERVE_COUPON_SUCCESS]: () => false,
    [types.RESERVE_COUPON_FAILURE]: () => false,
  }),
  data: createReducer(null, {
    [types.RESERVE_COUPON_SUCCESS]: (_, { data }) => data,
    [types.RESERVE_COUPON_FAILURE]: () => null,
  }),
  error: createReducer(null, {
    [types.RESERVE_COUPON]: () => null,
    [types.RESERVE_COUPON_SUCCESS]: () => null,
    [types.RESERVE_COUPON_FAILURE]: (_, { error }) => error,
  }),
});

export default (state = {}, action) => {
  const { type, couponId } = action;

  if (Object.values(types).includes(type)) {
    return {
      ...state,
      [couponId]: reserveCoupon(state[couponId], action),
    };
  }

  return state;
};
